import { useMutation } from "react-query";
import { createCurrentCommunication, updateCurrentCommunication } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertCurrentCommunication = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload, isNew = false }: { clientId: number; payload: Record<string, any>; isNew?: boolean }) =>
      isNew ? createCurrentCommunication(clientId, payload) : updateCurrentCommunication(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving the current communication.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    upsertCurrentCommunicationMutation: mutate,
    isUpsertCurrentCommunicationLoading: isLoading,
    ...rest,
  };
};

export default useUpsertCurrentCommunication;
